// extracted by mini-css-extract-plugin
module.exports = {"writePostBtnWrapper":"styles-module__writePostBtnWrapper___1isVc","writePostBtn":"styles-module__writePostBtn___2xycc"};